<template>
  <Teleport to="#teleports">
    <div
      v-if="open"
      class="fixed top-0 left-0 right-0 bottom-0 bg-black/90 flex flex-col items-center justify-center gap-8 z-[1000] font-inter"
    >
      <font-awesome-icon
        v-if="loading"
        icon="fa-solid fa-spinner"
        class="text-8xl text-white/50 animate-spin [animation-duration:3000ms]"
      />
      <span class="text-white text-2xl font-bold">
        <slot>Loading...</slot>
      </span>
    </div>
  </Teleport>
</template>

<script setup>
  defineProps({
    loading: {
      type: Boolean,
      default: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
  })
</script>
